// extracted by mini-css-extract-plugin
module.exports = {"preset":"style_preset__2uPhD"};